"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _getUserFullName = _interopRequireDefault(require("@devsta/get-user-full-name"));

var _SubscriptionBlock = _interopRequireDefault(require("../../SubscriptionBlock"));

var _AssignmentList = _interopRequireDefault(require("../../AssignmentList"));

var _TeamDetails = _interopRequireDefault(require("./TeamDetails"));

var _buildTeamDescription = _interopRequireDefault(require("../utils/buildTeamDescription"));

var _SetAssignmentModalTitle = _interopRequireDefault(require("../../../contexts/SetAssignmentModalTitle"));

var _utils = require("../../../utils");

require("../styles/_editing-team.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var getTeamName = function getTeamName(team) {
  return team.name;
};

var EditingTeam = /*#__PURE__*/function (_Component) {
  _inherits(EditingTeam, _Component);

  function EditingTeam(props) {
    var _this;

    _classCallCheck(this, EditingTeam);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EditingTeam).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "viewTeamDetails", (0, _lodash.default)(function (setModalTitle) {
      return function (team) {
        setModalTitle(team.name);

        _this.setState({
          selectedTeam: team
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "getTeamMapFromTeams", (0, _memoizeOne.default)(function (teams) {
      return new Map(teams.map(function (team) {
        return [team.teamId, team];
      }));
    }));

    _defineProperty(_assertThisInitialized(_this), "getOrganisationsWithTeams", (0, _memoizeOne.default)(function (organisations, teamMap) {
      return organisations.map(function (organisation) {
        if (!organisation.editingTeamId) {
          return organisation;
        }

        return _objectSpread({}, organisation, {
          editingTeam: teamMap.get(organisation.editingTeamId)
        });
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "onSave", function () {
      var onSave = _this.props.onSave;

      _this.setState(function (_ref) {
        var currentEditingTeam = _ref.currentEditingTeam,
            selectedTeam = _ref.selectedTeam;
        return {
          assignedEditingTeam: selectedTeam || currentEditingTeam
        };
      }, function () {
        var assignedEditingTeam = _this.state.assignedEditingTeam;
        onSave(assignedEditingTeam);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setAssignedEditingTeam", function (team) {
      _this.setState(function (_ref2) {
        var currentEditingTeam = _ref2.currentEditingTeam;
        return {
          currentEditingTeam: currentEditingTeam && currentEditingTeam.teamId === team.teamId ? void 0 : team
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleAssignModalToggle", function (_ref3) {
      var closed = _ref3.closed;

      if (closed) {
        _this.setState(function (_ref4) {
          var assignedEditingTeam = _ref4.assignedEditingTeam;
          return {
            currentEditingTeam: assignedEditingTeam,
            selectedTeam: void 0
          };
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearTeamDetails", function () {
      _this.setState({
        selectedTeam: void 0
      });
    });

    _this.state = {
      assignedEditingTeam: props.assignedEditingTeam,
      currentEditingTeam: props.assignedEditingTeam,
      selectedTeam: void 0
    };
    return _this;
  }

  _createClass(EditingTeam, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          currentEditingTeam = _this$state.currentEditingTeam,
          assignedEditingTeam = _this$state.assignedEditingTeam,
          selectedTeam = _this$state.selectedTeam;
      var _this$props = this.props,
          title = _this$props.title,
          teams = _this$props.teams,
          organisations = _this$props.organisations,
          disabled = _this$props.disabled;
      var list = selectedTeam ? selectedTeam.membersPreview : teams;
      var teamMap = this.getTeamMapFromTeams(teams);
      var footerContent = selectedTeam ? _react.default.createElement(_TeamDetails.default, {
        organisations: this.getOrganisationsWithTeams(organisations, teamMap),
        team: selectedTeam
      }) : void 0;
      var saveBtnText = selectedTeam ? 'Assign Team' : void 0;
      var getItemDisplayName = selectedTeam ? _getUserFullName.default : getTeamName;
      var getItemDescription = selectedTeam ? _utils.buildUserDescription : _buildTeamDescription.default;
      var onImageClick = selectedTeam ? void 0 : this.viewTeamDetails;
      var onBackClick = selectedTeam ? this.clearTeamDetails : void 0;
      return _react.default.createElement(_SubscriptionBlock.default, {
        id: "editing-team",
        className: "editing-team",
        title: title,
        defaultImage: "editing",
        assignmentType: "Editors",
        assignedDescriptions: assignedEditingTeam ? (0, _buildTeamDescription.default)(assignedEditingTeam) : void 0,
        assignedName: assignedEditingTeam && assignedEditingTeam.name,
        image: assignedEditingTeam && assignedEditingTeam.imageUrl,
        onSave: this.onSave,
        onToggleModal: this.handleAssignModalToggle,
        saveBtnText: saveBtnText,
        onBackClick: onBackClick,
        disabled: disabled,
        assignmentModalContent: _react.default.createElement(_SetAssignmentModalTitle.default.Consumer, null, function (setModalTitle) {
          return _react.default.createElement(_AssignmentList.default, {
            list: list,
            onAssignItem: _this2.setAssignedEditingTeam,
            assignedItem: currentEditingTeam,
            assignmentMatchField: "teamId",
            getItemDisplayName: getItemDisplayName,
            getItemDescription: getItemDescription,
            onImageClick: onImageClick ? onImageClick(setModalTitle) : void 0,
            hideFilter: Boolean(selectedTeam),
            footerContent: footerContent,
            hideAssignmentBtns: Boolean(selectedTeam)
          });
        })
      });
    }
  }]);

  return EditingTeam;
}(_react.Component);

exports.default = EditingTeam;